import { IndicatorOrTag } from "@/modules/DashboardTemplate/models/IndicatorOrTag";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue } from "vue-property-decorator";
import IndicatorView from "../../IndicatorView/IndicatorView.vue";

@Component({
  name: "TagsOfSection",
  components: { IndicatorView },
  computed: {}
})
export default class TagsOfSection extends Vue {
  @Prop({ required: true }) tags!: IndicatorOrTag[];
  @Prop({ required: true, default: "" }) title!: string;
  @Prop({ required: true, default: "" }) description!: string;

  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;

  editTag(index: number) {
    this.$emit("edit-tag", index);
  }

  deleteTag(index: number) {
    this.$emit("delete-tag", index);
  }

  toggleShow(index: number) {
    this.$emit("toggle-tag", index);
  }
}
